// --
import React from 'react';
import {ListGroup, ListGroupItem} from "reactstrap";
import AbstractField from "./AbstractField";
import "./ListSelectField.scss";
import classNames from "classnames";

/**
 * Komponenta seznamu položek s možností jednu vybrat. Jedná se o standardní field s onChange metodou.
 */
class ListSelectField extends AbstractField {
    static PropTypes = {
        items: React.PropTypes.array.isRequired, // seznam položek
        idAttrName: React.PropTypes.string,  // název atributu pro určení id
        renderItem: React.PropTypes.func,   // render řádku
    };

    static defaultProps = {
        idAttrName: "id",
        renderItem: (x => x.name)
    };

    render() {
        const {renderItem, className, idAttrName, onChange, value, items} = this.props;

        const cls = classNames("list-select-field", className);

        const field = <ListGroup className={cls}>
            {items.map(item => {
                let active;
                if (value != null) {
                    if (item[idAttrName] != null && value[idAttrName] != null) {
                        active = item === value;
                    } else {
                        active = item[idAttrName] === value[idAttrName];
                    }
                }
                return <ListGroupItem active={active} onClick={() => {onChange && onChange(item)}}>
                    {renderItem(item)}
                </ListGroupItem>
            })}
        </ListGroup>

        return this.renderFieldWithAddons(field);
    }
}

export default ListSelectField;
